import { useTotalRentCache } from '../../queries/useTotalRentCache';
import { singleStructures } from '../../../../../../constants/singleStructures';
import { formatCurrencyOrUndefined } from '@apply/ui';

interface MobileUnitInformationFooterProps {
    propertyGuid: string;
    type: string;
}

export const MobileUnitInformationFooter: React.FC<MobileUnitInformationFooterProps> = ({ propertyGuid, type }) => {
    const totalRent = useTotalRentCache(propertyGuid);

    return (
        <>
            {!singleStructures.includes(type) && (
                <div className='unit-info-footer'>
                    <h4>
                        Total Rent :<span style={{ marginLeft: '20px' }}>{formatCurrencyOrUndefined(totalRent, 0)}</span>
                    </h4>
                </div>
            )}
        </>
    );
};
